<template>
  <v-row>
    <v-col cols="12">
      <php-manager-list />
    </v-col>
  </v-row>
</template>

<script>
import PhpManagerList from '@/components/Services/Hosting/Shared/Php/PhpManager/PhpManagerList'

export default {
  name: 'PhpManagerView',
  components: { PhpManagerList }
}
</script>
